export const raceData = [
  {
    id: "slamet-100",
    name: "Brutal 50",
    distance: "50 KM",
    elevation: "2.500 M+",
    description: "Ujian ketahanan tertinggi melintasi jalur menantang di lereng Gunung Slamet. Hanya untuk pelari paling berani.",
    longDescription: "Brutal 50 adalah mahkota dari Banyumas ultra. Rute ini dirancang untuk menguji batas fisik dan mental Anda, membawa Anda melewati hutan lebat dan punggungan gunung yang ikonik. Anda akan mengalami perubahan cuaca drastis, jalur teknis yang menantang, dan pemandangan yang akan membuat semua penderitaan terbayar lunas.",
    bgClass: "from-red-500/10 to-background",
    borderColor: "border-red-500/50",
    heroImage: "https://images.unsplash.com/photo-1589484722364-954915758235?auto=format&fit=crop&w=1740&q=80",
    cutOffTime: "15 Jam",
    itraPoints: "3",
    waterStations: "5 WS",
    price: "Rp870.000",
    checkpoints: [
        
    ]
  },
  {
    id: "baturaden-50",
    name: "Banyumas 25",
    distance: "25 KM",
    elevation: "1.200 M+",
    description: "Tantangan indah menyusuri hutan pinus dan sungai-sungai jernih. Keindahan dan kebrutalan dalam satu paket.",
    longDescription: "Banyumas 25 adalah perpaduan sempurna antara keindahan alam dan tantangan teknis. Jalur ini akan membawa Anda menyusuri punggungan bukit yang dramatis, melewati perkebunan teh, dan menuruni lembah-lembah subur. Ini adalah ultramaraton sejati yang akan memuaskan jiwa petualang Anda.",
    bgClass: "from-blue-500/10 to-background",
    borderColor: "border-blue-500/50",
    heroImage: "https://images.unsplash.com/photo-1617953141905-cde726013422?auto=format&fit=crop&w=1740&q=80",
    cutOffTime: "9 Jam",
    itraPoints: "1",
    waterStations: "3 WS",
    price: "Rp690.000",
    checkpoints: [
        
    ]
  },
  {
    id: "jungle-25",
    name: "JUNGLE 15K",
    distance: "15 KM",
    elevation: "800 M+",
    description: "Jalur cepat dan menantang melewati curug tersembunyi dan hutan damar. Kombinasi sempurna antara kecepatan dan teknik.",
    longDescription: "Jungle 15K menawarkan pengalaman lari trail klasik dengan semua elemen terbaik: tanjakan curam, turunan cepat, dan pemandangan alam yang menakjubkan. Anda akan berlari melewati air terjun yang indah, memberikan kesegaran pada petualangan fisik Anda.",
    bgClass: "from-green-500/10 to-background",
    borderColor: "border-green-500/50",
    heroImage: "https://images.unsplash.com/photo-1543973157-1049528c8745?auto=format&fit=crop&w=1740&q=80",
    cutOffTime: "6 Jam",
    itraPoints: "0",
    waterStations: "2 WS",
    price: "Rp525.000",
    checkpoints: [
        
    ]
  },
  {
    id: "forest-10",
    name: "BATURADEN 7",
    distance: "7 KM",
    elevation: "350 M+",
    description: "Perkenalan yang sempurna dengan lari trail di Baturaden. Nikmati pemandangan menakjubkan tanpa tekanan.",
    longDescription: "Baturaden 7 adalah gerbang Anda menuju dunia lari trail. Dengan jarak yang lebih bersahabat namun tetap menantang, rute ini menawarkan pemandangan spektakuler dari Small World dan sekitarnya. Ini adalah cara terbaik untuk merasakan keajaiban alam Baturaden.",
    bgClass: "from-yellow-500/10 to-background",
    borderColor: "border-yellow-500/50",
    heroImage: "https://images.unsplash.com/photo-1598973405033-503a7c15a0b4?auto=format&fit=crop&w=1740&q=80",
    cutOffTime: "4 Jam",
    itraPoints: "0",
    waterStations: "1 WS",
    price: "Rp295.000",
    checkpoints: [
        
    ]
  },
];